import React from 'react';
import CompApropos from '../components/CompApropos';



const Apropos = () => {
    return (
     <div>
        <CompApropos />

     </div>

     );
    }
    
    export default Apropos